<p-timeline [value]="orderDetailedStatus">
  <ng-template pTemplate="marker" let-status>
    <div
      class="p-timeline-event-marker"
      [ngClass]="{
        'p-timeline-event-marker-success': status.isCompleted,
        'p-timeline-event-marker-warning': !status.isCompleted
      }"
    ></div>
  </ng-template>
  <ng-template pTemplate="content" let-status>
    <p class="p3 font-semibold mt-0 mb-1" data-cy="order-detailed-status-name">{{ status.name }}</p>
    <p *ngIf="status.description" class="p3 my-0 text-black-400" data-cy="order-detailed-status-description">
      {{ status.description }}
    </p>
  </ng-template>
</p-timeline>
